module.exports = __webpack_public_path__ + "static/media/img2Mobile.a712b428.jpg";